import React from "react";
import styled from "styled-components";
import FooterLinkItem from "../../components/Footer/FooterLinkItem";
import content from "../../content";

const FooterWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 50px;
  min-height: 50px;
  padding: 0 32px;
  background-color: #f9f9f9;
`;

const LinkWrapper = styled.div`
  display: flex;
`;

function Footer({}: IFooter) {
  return (
      <FooterWrapper>
        <LinkWrapper>
          <FooterLinkItem href={"#"}>
            {content.getValue("footer_regulations")}
          </FooterLinkItem>
          <FooterLinkItem href={"#"}>
            {content.getValue("footer_privacy")}
          </FooterLinkItem>
          <FooterLinkItem href={"#"}>
            {content.getValue("footer_complaints")}
          </FooterLinkItem>
          <FooterLinkItem href={"#"}>
            {content.getValue("Strona www")}
          </FooterLinkItem>
        </LinkWrapper>
      </FooterWrapper>
  );
}

export interface IFooter {}

export default Footer;
